module.exports = __webpack_public_path__ + "img/whatsapp-icon-mobile-zh-HK.a3de731.png";